export default __webpack_public_path__ + "static/media/developer.a283fa5b.svg";